"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ShiftOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ShiftOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 1.646a.5.5 0 0 0-.708.708L14.293 4H11.92a2.5 2.5 0 0 0-1.898.873l-4.803 5.603A1.5 1.5 0 0 1 4.08 11H.5a.5.5 0 0 0 0 1h3.58a2.5 2.5 0 0 0 1.898-.873l4.803-5.603A1.5 1.5 0 0 1 11.92 5h2.373l-1.647 1.646a.5.5 0 0 0 .708.708l2.516-2.518a.498.498 0 0 0-.018-.69l-2.498-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.341 6.463-.658.769-1.464-1.708A1.5 1.5 0 0 0 4.08 5H.5a.5.5 0 0 1 0-1h3.58a2.5 2.5 0 0 1 1.898.873l1.363 1.59ZM10.781 10.476A1.5 1.5 0 0 0 11.92 11h2.373l-1.647-1.646a.5.5 0 0 1 .708-.708l2.506 2.507a.498.498 0 0 1-.006.7l-2.5 2.5a.5.5 0 0 1-.708-.707L14.293 12H11.92a2.5 2.5 0 0 1-1.898-.873l-1.363-1.59.658-.769 1.464 1.708Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ShiftOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ShiftOutline;
exports["default"] = _default;